import React, { useEffect, useRef } from 'react'
import { useLocation } from 'react-router'
import { isVccSensitivePath, reloadForSensitiveRoute } from '../utils/vccPrivacy'

/** Non monta il form finché non è garantito un documento privo di session recording. */
export default function VccPrivacyBoundary ({ children }) {
  const { pathname } = useLocation()
  const sensitive = isVccSensitivePath(pathname)
  const visitedUnprotected = useRef(!isVccSensitivePath(window.location.pathname))
  if (!sensitive) visitedUnprotected.current = true
  const reload = sensitive && visitedUnprotected.current
  useEffect(() => {
    if (reload) reloadForSensitiveRoute()
  }, [reload])
  return reload ? null : <>{children(sensitive)}</>
}
